module.exports = __webpack_public_path__ + "img/USAMap.010e7851.png";